import { IBaseDialogStoreState, BaseDialogStoreState } from '../baseDialogStoreState';

export interface ICreateGroupAccountDialogStoreState extends IBaseDialogStoreState { }

export class CreateGroupAccountDialogStoreState extends BaseDialogStoreState implements ICreateGroupAccountDialogStoreState {
    constructor() {
        super();
    }
}